import React, { useState, useEffect } from 'react';
import Axios from "axios";

import { MDBListGroup, MDBListGroupItem, MDBCheckbox, MDBBtn } from 'mdb-react-ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from "@fortawesome/free-solid-svg-icons";

import { CSVLink } from "react-csv";
import { backendPathTasks } from '../Constants';
import ExcelExport from "./ExcelExport";
import Moment from "moment";


function ExportTasks() {
    const [taskList, setTaskList] = useState([]);
    const [taskOptions, setTaskOptions] = useState({startDate: 0, endDate: 0, customer: 0, employee: 0, annotation: 0});
    const [tasksGenerated, setTasksGenerated] = useState(false);
    const [csvData, setCSVData] = useState([]);


    const getTasks = (c) => {
        Axios.get(backendPathTasks+"tasks-employee-customer.php").then((response) => {
            setTaskList(response.data);
            console.log(response.data);
        });
    }

    const taskOptionsSelected = () => {
        return taskOptions.startDate || taskOptions.endDate || taskOptions.customer || taskOptions.employee || taskOptions.annotation;
    };

    const generateTasks = () => {
        console.log(taskOptions);
        getTasks();
    };

    const handleChange = () => {
        setTasksGenerated(false);
        setCSVData([]);
    };

    useEffect(() => {
        if (taskList.length && !tasksGenerated) {
            const data = [];
            const columns = [];
            console.log(taskOptions);
            if (taskOptions.startDate) {
                columns.push("Startdatum");
            }
            if (taskOptions.endDate) {
                columns.push("Enddatum");
            }
            if (taskOptions.customer) {
                columns.push("Kunde");
            }
            if (taskOptions.employee) {
                columns.push("Betreuer");
            }
            if (taskOptions.annotation) {
                columns.push("Anmerkungen");
            }
            data.push(columns);
            console.log(data);

            for (let i=0; i<taskList.length; i++) {
                const row = [];
                if (taskOptions.startDate) {
                    row.push(Moment(taskList[i].StartDate, "YYYY-MM-DD").format("DD.MM.YYYY"));
                }
                if (taskOptions.endDate) {
                    row.push(Moment(taskList[i].EndDate, "YYYY-MM-DD").format("DD.MM.YYYY"));
                }
                if (taskOptions.customer) {
                    row.push(taskList[i].FirstNameC + " " + taskList[i].LastNameC);
                }
                if (taskOptions.employee) {
                    row.push(taskList[i].FirstNameE + " " + taskList[i].LastNameE);
                }
                if (taskOptions.annotation) {
                    row.push(taskList[i].Annotation);
                }
                data.push(row);
            }
            console.log(data);
            setCSVData(data);
            setTasksGenerated(true);
        }
    }, [taskList]);


    return (
        <div>

            <div className='header2'>
                <h3>Einsätze</h3>
                <MDBListGroup light>
                    <MDBListGroupItem>
                        <MDBCheckbox inline onChange={(e) => {handleChange(); setTaskOptions({startDate: e.target.checked, endDate: e.target.checked, customer: e.target.checked, employee: e.target.checked, annotation: e.target.checked})}} />
                        alles auswählen
                    </MDBListGroupItem>
                </MDBListGroup>
            </div>

            <MDBListGroup style={{ minWidth: '22rem' }} light>
                <MDBListGroupItem>
                    <MDBCheckbox inline checked={taskOptions.startDate} onChange={(event) => {handleChange(); setTaskOptions({startDate: (taskOptions.startDate+1)%2, endDate: taskOptions.endDate, customer: taskOptions.customer, employee: taskOptions.employee, annotation: taskOptions.annotation})}} />
                    Startdatum
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={taskOptions.endDate} onChange={(event) => {handleChange(); setTaskOptions({startDate: taskOptions.startDate, endDate: (taskOptions.endDate+1)%2, customer: taskOptions.customer, employee: taskOptions.employee, annotation: taskOptions.annotation})}} />
                    Enddatum
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={taskOptions.customer} onChange={(event) => {handleChange(); setTaskOptions({startDate: taskOptions.startDate, endDate: taskOptions.endDate, customer: (taskOptions.customer+1)%2, employee: taskOptions.employee, annotation: taskOptions.annotation})}} />
                    Kunde
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={taskOptions.employee} onChange={(event) => {handleChange(); setTaskOptions({startDate: taskOptions.startDate, endDate: taskOptions.endDate, customer: taskOptions.customer, employee: (taskOptions.employee+1)%2, annotation: taskOptions.annotation})}} />
                    Betreuer
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={taskOptions.annotation} onChange={(event) => {handleChange(); setTaskOptions({startDate: taskOptions.startDate, endDate: taskOptions.endDate, customer: taskOptions.customer, employee: taskOptions.employee, annotation: (taskOptions.annotation+1)%2})}} />
                    Anmerkungen
                </MDBListGroupItem>
            </MDBListGroup>

            <div className="footer export">
                {!taskOptionsSelected() ?
                    <MDBBtn className="btn-disabled" disabled type="submit">
                        Tabelle generieren
                    </MDBBtn>
                : 
                (tasksGenerated && csvData.length) ?
                    <>
                        <MDBBtn className="btn btn-csv" type="submit" onClick={() => document.getElementById("csv-link-task").click()}>
                            <CSVLink id="csv-link-task" filename='Einsätze' data={csvData}>
                                <FontAwesomeIcon className='btn-icon' icon={faDownload} />
                                CSV herunterladen
                            </CSVLink>
                        </MDBBtn>

                        <ExcelExport data={csvData} fileName="Einsätze" />
                    </>
                :
                    <MDBBtn className="btn" type="submit" onClick={generateTasks}>
                        Tabelle generieren
                    </MDBBtn>
                }
            </div>
        </div>
    );
}

export default ExportTasks;